/** */
import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut, apiDelete } from 'services/_http';

/** */
const base_url = `${urls.iam}/announcements`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const updateById = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};

export const deleteById = async (id, options = {}) => {
  return await apiDelete(`${base_url}/${id}`, { ...options });
};
